import { render, staticRenderFns } from "./OrderActionVoid.vue?vue&type=template&id=3086b6e7&"
import script from "./OrderActionVoid.vue?vue&type=script&lang=ts&"
export * from "./OrderActionVoid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports